import React from 'react';
import PageContainer from '../PageContainer';
import './identity-cards.scss';
import AnimatedCard from './animatedCard';
import cards from './cards';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import PageTitle from '../PageTitle';
import { greyText } from '../styles';

class IdentityCards extends React.Component {

  constructor() {
    super();
    this.state = { currentCard: "" };

  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ currentCard: cards[0] });
    }, 2000);
  }

  prevCard() {
    let currentIndex = cards.indexOf(this.state.currentCard);
    currentIndex--;
    if (currentIndex < 0) {
      currentIndex = cards.length - 1;
    }
    this.setState({ currentCard: cards[currentIndex] });
  }

  nextCard() {
    let currentIndex = cards.indexOf(this.state.currentCard);
    currentIndex++;
    if (currentIndex > cards.length) {
      currentIndex = 0;
    }
    this.setState({ currentCard: cards[currentIndex] });
  }

  openCard() {
    this.setState({ currentCard: cards[this.state.currentHovering || 0] })

  }

  closeCard() {
    this.setState({ currentCard: null })
  }

  mouseIn(e, i) {
    let rect = e.target.getBoundingClientRect();
    let top = rect.top + (rect.height / 2);
    let left = rect.left + (rect.width / 2);
    this.setState({ left, top, currentHovering: i });
  }

  render() {
    let dotStyle = { top: this.state.top + 'px', left: this.state.left + 'px' }
    let cardIndex = cards.indexOf(this.state.currentCard) || 0;
    return (
      <PageContainer {...this.props} className="identity-cards">

        <CSSTransition timeout={500} in={this.state.currentCard !== ""} >

          <div className="identity-cards-content">


            <div className="counter">
              <SwitchTransition>

                <CSSTransition classNames='fade'
                  timeout={2000} key={cardIndex} in={this.state.currentCard !== ""} >
                  <span> {cardIndex + 1}</span>
                </CSSTransition>
              </SwitchTransition>

              <span> / {cards.length}</span>
            </div>

            {/* <div className="cards-container">
            {cards.map((card, i) => <div key={"card-" + i} onMouseEnter={(e) => this.mouseIn(e, i)} className="card" />)}
            {this.state.currentCard === null && <div className="dot" style={dotStyle} onClick={() => this.openCard()} />}
          </div> */}
            <div className="cards-container">
              <div className="prev-slide" style={{ cursor: 'pointer' }} onClick={this.prevCard.bind(this)}><FontAwesomeIcon icon={faChevronLeft} /></div>

              <AnimatedCard src={this.state.currentCard} />

              <div className="next-slide" style={{ cursor: 'pointer' }} onClick={this.nextCard.bind(this)}><FontAwesomeIcon icon={faChevronRight} /></div>

            </div>
          </div>

        </CSSTransition>

        <PageTitle>What does identity mean to you?</PageTitle>
        <div className="page-subtitle">
          <i>Take a look at what some of the viewers from the physical exhibition (held at ARKIVET summer of 2019) were thinking and feeling about identity</i>
          <br />
          <i style={{ color: greyText }} >Ta en titt på hva noen av de besøkende av den fysiske utstillingen (holdt på ARKIVET sommeren 2019) tenkte og følte om identitet</i>
        </div>

      </PageContainer>
    );
  }
}

export default IdentityCards;
//            <div className="card-border" style={{ backgroundImage:  `url( ${cardBorder})` }} />
